// ThemeContext - Manages theme state and custom styling
import React, { createContext, useContext } from 'react';

const ThemeContext = createContext({
  theme: 'classic',
  settings: {}
});

export function ThemeProvider({ theme, settings, children }) {
  return (
    <ThemeContext.Provider value={{ theme, settings }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}

export default ThemeContext;
